import { z } from "zod";
import { TObjectBase, TApiObjectBase, TFile } from "../base";
import { TModuleID, TPropertyModule } from "../module/module";
import { TApiPropertyInfoFields } from "./infoFields/propertyInfoFields.api";
import { TTranslationLangSchema } from "../common/translation";

export type IPropertyRoleTitle = z.infer<typeof TPropertyRoleTitle>;
export const TPropertyRoleTitle = z
  .object({
    id: z.string().nullish(),
  })
  .extend(TTranslationLangSchema.shape);

export type IPropertyDashboardData = z.infer<typeof TPropertyDashboardData>;
export const TPropertyDashboardData = z.object({
  body: z.string().optional(),
  enabled: z.boolean().optional(),
  title: z.string().optional(),
});

export type IRawProperty = z.infer<typeof TRawProperty>;
export const TRawProperty = z
  .object({
    name: z.string().optional(),
    bookingCount: z.number().optional(),
    companies: z.array(z.string()).optional(),
    contractorGroups: z.array(z.string()).optional(),
    /** @deprecated `dashboardData` is deprecated and will to be removed in the near future */
    dashboardData: TPropertyDashboardData.optional(),
    deviationCount: z.number().optional(),
    headerImage: TFile.optional(),
    smallHeaderImage: TFile.optional(),
    isDemoProperty: z.boolean().nullish(),
    /** @deprecated `modules` is deprecated has been moved to the `settings` subcollection (/properties/:id/settings/:id) */
    modules: z.record(TModuleID, TPropertyModule).optional(),
    roleTitles: z.record(z.string(), TPropertyRoleTitle).optional(),
    propertyIndex: z.number().optional(),
  })
  .extend(TObjectBase.shape);

export type IApiProperty = z.infer<typeof TApiProperty>;
export const TApiProperty = TApiObjectBase.extend({
  archived: z.boolean().default(false),
  name: z.string().optional(),
  companies: z.array(z.string()).optional(),
  contractorGroups: z.array(z.string()).optional(),
  headerImage: TFile.optional(),
  smallHeaderImage: TFile.optional(),
  propertyIndex: z.number().optional(),
  fields: TApiPropertyInfoFields.default({}),
});
